/**
 * «Чат | Доска ⟨N⟩» below the two-column breakpoint.
 *
 * **There is no auto-switching.** N counts what has appeared on the board since
 * it was last looked at, and a toast offers the jump — switching the pane for
 * somebody who is typing steals their focus, and the board will still be there
 * a second later.
 */

import { useSurface } from '../a2ui/surfaceStore';
import { cn } from '../lib/cn';

export type Pane = 'chat' | 'board';

export default function MobileTabs({
  pane,
  onChange,
}: {
  pane: Pane;
  onChange: (pane: Pane) => void;
}) {
  const unseen = useSurface((state) => state.unseen);

  return (
    <div className="segments" role="tablist" aria-label="Что показать">
      <button
        type="button"
        role="tab"
        aria-selected={pane === 'chat'}
        className="segments__item"
        onClick={() => onChange('chat')}
      >
        Чат
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={pane === 'board'}
        className={cn('segments__item')}
        onClick={() => onChange('board')}
      >
        Доска
        {unseen > 0 && pane !== 'board' ? (
          <span className="segments__badge">{unseen > 9 ? '9+' : unseen}</span>
        ) : null}
      </button>
    </div>
  );
}
